<ng-container>
  <div class="card mt-20">
    <div class="body">
        <div class="block-buttons top-card mb-10">
            <button type="button" (click)="openAddUpdatePopup()">+ Add</button>
            <button type="button" (click)="goto('/seller/sell-offer/bulk-import')">+ Bulk Import</button>
            <button type="button" (click)="openFTPDetailsPopup()">+ FTP Details</button>
        </div>

      <table mat-table [dataSource]="sellOfferList" matSort matSortActive="DateEntered" matSortDisableClear
        matSortDirection="desc" class="offer-summmary-table">
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
          <td mat-cell *matCellDef="let element,let i =index">{{i+1}}</td>
        </ng-container>
        <ng-container matColumnDef="UtilityName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility</th>
          <td mat-cell *matCellDef="let element"> {{element.utility.name}} </td>
        </ng-container>
        <ng-container matColumnDef="LoadZone">
          <th mat-header-cell *matHeaderCellDef>Load Zone</th>
          <td mat-cell *matCellDef="let element">
            {{element.loadZone.name}}
          </td>
        </ng-container>
        <ng-container matColumnDef="RateClass">
          <th mat-header-cell *matHeaderCellDef>Rate Class</th>
          <td mat-cell class="short-list-view" *matCellDef="let element">
            @for (rateClass of element.rateClasses; track rateClass) {
              <span>{{rateClass.name}}</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="StartingOn">
          <th mat-header-cell *matHeaderCellDef>Starting On</th>
          <td mat-cell *matCellDef="let element"> {{element.termFrom | date:'shortDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="TermPeriod">
          <th mat-header-cell *matHeaderCellDef>Term Period</th>
          <td mat-cell *matCellDef="let element"> {{element.termPeriod}} months</td>
        </ng-container>
        <ng-container matColumnDef="TargetPrice">
          <th mat-header-cell *matHeaderCellDef>Seller's Price</th>
          <td mat-cell *matCellDef="let element"> {{element.priceForSeller() | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
        </ng-container>
        <ng-container matColumnDef="Fee">
          <th mat-header-cell *matHeaderCellDef>License Fee</th>
          <td mat-cell *matCellDef="let element"> {{element.fee | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
        </ng-container>
        <ng-container matColumnDef="Price">
          <th mat-header-cell *matHeaderCellDef>Sales Price <div class="notifiedIconSmall cursor-pointer" (click)="iIconPopup('Sales Price includes Licence Fee. Seller\'s price is estimated as Sales Price minus License Fee.')"></div></th>
          <td mat-cell *matCellDef="let element"> {{element.priceForBuyer() | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
        </ng-container>
        <ng-container matColumnDef="ValidUntil">
          <th mat-header-cell *matHeaderCellDef>Valid Until</th>
          <td mat-cell *matCellDef="let element"> {{element.validDate | date:'short'}} EST </td>
        </ng-container>
        <ng-container matColumnDef="ContractTerms">
          <th mat-header-cell *matHeaderCellDef>Sales Agreement</th>
          <td mat-cell *matCellDef="let element"> {{element.sellerContract.name}} </td>
        </ng-container>
        <ng-container matColumnDef="CreatedBy">
          <th mat-header-cell *matHeaderCellDef>Created By</th>
          <td mat-cell *matCellDef="let element"> {{element.user.firstName}} {{element.user.lastName}} </td>
        </ng-container>
        <ng-container matColumnDef="DateEntered">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Updated</th>
          <td mat-cell *matCellDef="let element"> {{element.dateUpdated | date:'short'}} EST </td>
        </ng-container>

        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell class="text-nowarp" *matCellDef="let element,let i = index">
            <a class="link f18" (click)="copySellOffer(element)">
              <mat-icon class="customIcons">content_copy</mat-icon>
            </a>
            <a class="link f18" (click)="deleteSellOffer(element)">
              <mat-icon class="customIcons">delete_outline</mat-icon>
            </a>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row [class]="(row.isNewRecord)?'higlighted':''" (click)="markSellOfferNotNew(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [hidePageSize]="true" [length]="total" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
    </div>
  </div>
</ng-container>
